module.exports = __webpack_public_path__ + "media/favicon/android-chrome-512x512-0f6df39e.png";